import React from "react";

const SystemVarsPage = () => {
  return <div>Welcome to SystemVars Page</div>;
}

export default SystemVarsPage;
